import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#removeable-tag" }),
  /*#__PURE__*/_createTextVNode(" Removable Tag ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
        return (_openBlock(), _createBlock(_component_el_tag, {
          key: tag.name,
          closable: "",
          type: tag.type
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tag.name), 1)
          ]),
          _: 2
        }, 1032, ["type"]))
      }), 128)),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}